import { render, staticRenderFns } from "./PageLayoutTable.vue?vue&type=template&id=48d8fe44&"
import script from "./PageLayoutTable.vue?vue&type=script&lang=js&"
export * from "./PageLayoutTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports